const isNewConsumerApp = !!process.env.NEXT_PUBLIC_IS_NEXT_APP;

export default isNewConsumerApp;
